import React from "react";
import "./App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import CaseStudies from "./components/CaseStudies";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/case-studies" element={<CaseStudies />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;